<script setup lang="ts" generic="Value extends string">
import { computed } from 'vue';
import { container } from '@shared/common/dependency-injection/domain/container';
import type { FormFieldTextComponent } from '@shared/common/form/application/component/text/form-field-text-component.types';
import { FormDependencyTypes } from '@shared/common/form/form.dependency-types';
import FormFieldMessages from '@shared/common/form/application/component/FormFieldMessages.vue';
import type { TextFormField } from '@shared/common/form/domain/form/field/text.form-field';

const model = defineModel<TextFormField<Value>>({ required: true });
const component = container.get<FormFieldTextComponent>(FormDependencyTypes.FormFieldTextComponent);

const message = computed(() => model.value.errorMessages?.[0]);
const additionalErrors = computed(() => model.value.errorMessages?.slice(1));
</script>

<template>
  <div>
    <component
      :is="component"
      :id="model.id"
      v-model="model.value"
      :label="model.label"
      :hint="model.hint"
      :placeholder="model.placeholder"
      :disabled="model.disabled"
      :message="message"
      :error="message"
    />
    <FormFieldMessages :errors="additionalErrors" />
  </div>
</template>
